import { ReviewStep } from '@shared/domain/review/index.js';

export const getReviewStepName = (step: ReviewStep): string => {
  switch (step) {
    case ReviewStep.BASIC_REVIEW: {
      return 'General Information';
    }
    case ReviewStep.ENTRY_STRATEGY: {
      return 'Entry Strategy';
    }
    case ReviewStep.EVALUATION: {
      return 'Evaluation';
    }
    case ReviewStep.LEGAL: {
      return 'Legal';
    }
    case ReviewStep.NEGOTIATION: {
      return 'Negotiation';
    }
    case ReviewStep.PURCHASE_DETAILS: {
      return 'Purchase Details';
    }
    case ReviewStep.RFP: {
      return 'RFP';
    }
    default: {
      return 'Review';
    }
  }
};
